import script from "./ImageScaler.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageScaler.vue?vue&type=script&setup=true&lang=js"

import "./ImageScaler.vue?vue&type=style&index=0&id=459c3397&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459c3397"]])

export default __exports__